import React, { useState, useEffect } from "react";
import "./RightSidebar.css";
import { useSelector } from "react-redux";
import { ServerAddress } from "../../constants/ServerAddress";
import axios from "axios";
import { SlCalender } from "react-icons/sl";
import { FaChevronCircleRight, FaGift } from "react-icons/fa";
import { FaCircleChevronLeft, FaCircleChevronRight } from "react-icons/fa6";
import useWindowDimensions from "./ScreenSize";
import { Navigate, useNavigate } from "react-router-dom";
import AliceCarousel from "react-alice-carousel";
import Modal from "react-bootstrap/Modal";
import { Button } from "reactstrap";
import BirthdayModal from "./timeLineSection/birthDay/BirthdayModal";
import toTitleCase from "../../lib/titleCase/TitleCase";

const RightSidebar = ({ holiday_data }) => {
  const accessToken = useSelector((state) => state.authentication.access_token);
  const user_details = useSelector((state) => state.authentication.userdetails);
  const user_bookmark = useSelector((state) => state.authentication.bookmarks);

  console.log(
    "user_details.bookmarktab1_url",
    user_details.bookmarktab2_url === null
  );

  const hasHRDepartment = useSelector((state) => {
    const departments = state.authentication.userdetails?.emp_department;
    return (
      Array.isArray(departments) && departments.some((dep) => dep.name === "HR")
    );
  });

  const isSuperUser = user_details?.is_superuser;

  const data = {
    quickLinks:
      isSuperUser || hasHRDepartment
        ? [
            { name: "Team Attendance", url: "myteam/TeamAttendance" },
            { name: "Attendance Correction", url: "TeamCorrectionRequest" },
            { name: "Leave Approve", url: "/ems/leave" },
            { name: "Onboard", url: "hr/onboardeduser" },
            { name: "Team Details", url: "ems/users" },
          ]
        : [
            { name: "Add Daily Task", url: "/ems/DailyTask/AddDailyTask" },
            { name: "Attendance", url: "/hr/EmpAttendance" },
            { name: "Leave", url: "/ems/leave" },
            { name: "Salary Slip", url: "/ems/payroll/payrollSlip/PaySlip" },
            { name: "Personal Details", url: "/userProfile/Profile" },
          ],
    icons: [
      {
        name: "WhatsApp",
        icon: "https://res.cloudinary.com/dwpjbjlip/image/upload/v1742889258/whatsapp_pcivys.png",
        link: "https://web.whatsapp.com/",
      },
      {
        name: "Email",
        icon: "https://res.cloudinary.com/dwpjbjlip/image/upload/v1742889258/email_tzimrt.png",
      },
      {
        name: "Quick Links",
        icon: "https://res.cloudinary.com/dwpjbjlip/image/upload/v1742889257/bookmark_emyxzn.png",
        link: "/BookMarksPages",
      },
      {
        name: "Calendar",
        icon: "https://res.cloudinary.com/dwpjbjlip/image/upload/v1742889257/calendar_aukkth.png",
        link: "/organisation/holidays/Holiday",
      },
      {
        name: "Attendance",
        icon: "https://res.cloudinary.com/dwpjbjlip/image/upload/v1742889258/task_dkbtn5.png",
        link: "/ems/attendance/myAttendance/MyAttendanceCalenderView",
      },
      {
        name: "Birthday",
        icon: "https://res.cloudinary.com/dwpjbjlip/image/upload/v1742889257/birthday_fv1zvy.png",
      },
    ],
    motivationalQuotes: [
      "Believe you can and you're halfway there.",
      "The best way to predict the future is to create it.",
    ],
  };

  // Birthday state and functions
  const [birthday_List, setbirthday_List] = useState([]);
  const today = new Date();
  const todayMonthDay =
    (today.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    today.getDate().toString().padStart(2, "0");

  let today_birthday = birthday_List.filter((item) => {
    if (item.Date !== null) {
      const itemMonthDay =
        item.Date.split("-")[1] + "-" + item.Date.split("-")[2];
      return itemMonthDay === todayMonthDay;
    }
    return false;
  });

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const get_birthday = () => {
    let final = [];
    axios
      .get(ServerAddress + `ems/get_user_birthday/?p=1`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      .then((response) => {
        let pair = response.data.results;
        pair.forEach((item) => {
          final.push({
            Date: item.date_of_birth,
            name: item.firstname,
            profile: item.profile_pic,
          });
        });
        setbirthday_List(final);
      })
      .catch((error) => {
        console.log(`Error while in get data,${error}`);
      });
  };

  useEffect(() => {
    if (accessToken) {
      get_birthday();
    }
  }, [accessToken]);

  // Flash updates carousel logic
  today.setHours(0, 0, 0, 0);
  const oneWeekFromNow = new Date(today);
  oneWeekFromNow.setDate(today.getDate() + 7);
  const [currentSlide, setCurrentSlide] = useState(0);

  const todayEvents = (birthday_List || []).filter(
    (event) => new Date(event.date).toDateString() === today.toDateString()
  );

  const upcomingEvents = (data.flashMessages || []).filter((event) => {
    const eventDate = new Date(event.date);
    return eventDate > today && eventDate <= oneWeekFromNow;
  });

  const getEventDetails = (event) => {
    switch (event.type) {
      case "birthday":
        return {
          title: "Birthday 🎂",
          message: `Happy Birthday ${event.name}!`,
          bg: "#FFEEF2",
        };
      case "anniversary":
        return {
          title: "Anniversary 💝",
          message: `${event.name}'s ${event.years} years!`,
          bg: "#F0F7FF",
        };
      case "festival":
        return {
          title: `${event.name} 🎉`,
          message: event.customMessage || "Celebrate!",
          bg: "#FFF9E6",
        };
      case "holiday":
        return {
          title: `${event.name} Holiday 🏖️`,
          message: "Enjoy your day off!",
          bg: "#E6FFED",
        };
      default:
        return { title: "Event", message: "", bg: "#F5F5F5" };
    }
  };

  const getMotivationalQuote = () => {
    const quotes = data.motivationalQuotes || [
      "Believe you can and you're halfway there.",
      "The only way to do great work is to love what you do.",
    ];
    return quotes[Math.floor(Math.random() * quotes.length)];
  };

  // Carousel controls
  const { height } = useWindowDimensions();
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === holiday_data.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? holiday_data.length - 1 : prevIndex - 1
    );
  };

  const handleHolidayclick = () => {
    navigate("/organisation/holidays/Holiday");
  };

  useEffect(() => {
    const timer = setInterval(() => {
      if (todayEvents.length > 1 || upcomingEvents.length > 1) nextSlide();
    }, 5000);
    return () => clearInterval(timer);
  }, [currentSlide]);

  const renderFlashContent = () => {
    if (todayEvents.length > 0) {
      const events = todayEvents;
      const event = events[currentSlide % events.length];
      const { title, message, bg } = getEventDetails(event);

      return (
        <div className="flash-card" style={{ backgroundColor: bg }}>
          <div className="flash-header">
            <span>{title}</span>
            <span className="date-badge">Today</span>
          </div>
          <div className="flash-body">
            <img src={event.image} alt={event.type} className="event-image" />
            <p className="event-message">{message}</p>
          </div>
          {events.length > 1 && (
            <div className="carousel-controls">
              <button onClick={prevSlide}>❮</button>
              <span>
                {currentSlide + 1}/{events.length}
              </span>
              <button onClick={nextSlide}>❯</button>
            </div>
          )}
        </div>
      );
    } else if (upcomingEvents.length > 0) {
      const events = upcomingEvents;
      const event = events[currentSlide % events.length];
      const { title, message, bg } = getEventDetails(event);
      const daysLeft = Math.ceil((new Date(event.date) - today) / 86400000);

      return (
        <div className="flash-card" style={{ backgroundColor: bg }}>
          <div className="flash-header">
            <span>Upcoming: {title}</span>
            <span className="date-badge">
              {daysLeft} day{daysLeft > 1 ? "s" : ""} left
            </span>
          </div>
          <div className="flash-body">
            <img src={event.image} alt={event.type} className="event-image" />
            <p className="event-message">{message}</p>
          </div>
          {events.length > 1 && (
            <div className="carousel-controls">
              <button onClick={prevSlide}>❮</button>
              <span>
                {currentSlide + 1}/{events.length}
              </span>
              <button onClick={nextSlide}>❯</button>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div className="quote-card">
          <p>"{getMotivationalQuote()}"</p>
        </div>
      );
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} className="custom_modal">
        <Modal.Header closeButton>
          <Modal.Title
            style={{ fontFamily: "'Poppins', sans-serif", fontSize: "400" }}
          >
            Today's Birthdays
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ background: "#454545" }}>
          {today_birthday.length === 0 ? (
            <div
              className="birt_day"
              style={{
                fontFamily: "Poppins sans-serif",
                fontSize: "400",
                color: "#f8fafc",
              }}
            >
              NO Birthdays Today
            </div>
          ) : (
            <BirthdayModal />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClose}
            style={{ fontFamily: "'Poppins', sans-serif", fontSize: "400" }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="right-sidebar">
        <div className="flash-updates">
          <h4
            style={{
              display: "flex",
              alignItems: "center",
              fontWeight: "600",
              borderBottom: "1.5px solid #f0f0f0",
              color: "#333",
            }}
          >
            Flash Updates
          </h4>
          {renderFlashContent()}
        </div>

        <div className="quick-links-container">
          <h4
            style={{
              display: "flex",
              alignItems: "center",
              fontWeight: "600",
              borderBottom: "1.5px solid #f0f0f0",
              color: "#333",
            }}
          >
            Quick Links
          </h4>
          <div className="quick-links-scroller">
            <ul>
              {user_bookmark?.bookmarks?.bookmarktab1_url !== null ? (
                <li>
                  <span
                    style={{ cursor: "pointer", color: "blue" }}
                    onClick={() =>
                      navigate(`/${user_bookmark?.bookmarks?.bookmarktab1_url}`)
                    }
                  >
                    {user_bookmark?.bookmarks?.bookmarktab1}
                  </span>
                </li>
              ) : user_bookmark?.bookmarks?.bookmarktab2_url !== null ? (
                <li>
                  <span
                    style={{ cursor: "pointer", color: "blue" }}
                    onClick={() =>
                      navigate(`/${user_bookmark?.bookmarks?.bookmarktab2_url}`)
                    }
                  >
                    {user_bookmark?.bookmarks?.bookmarktab2}
                  </span>
                </li>
              ) : user_bookmark?.bookmarks?.bookmarktab3_url !== null ? (
                <li>
                  <span
                    style={{ cursor: "pointer", color: "blue" }}
                    onClick={() =>
                      navigate(`/${user_bookmark?.bookmarks?.bookmarktab3_url}`)
                    }
                  >
                    {user_bookmark?.bookmarks?.bookmarktab3}
                  </span>
                </li>
              ) : user_bookmark?.bookmarks?.bookmarktab4_url !== null ? (
                <li>
                  <span
                    style={{ cursor: "pointer", color: "blue" }}
                    onClick={() =>
                      navigate(`/${user_bookmark?.bookmarks?.bookmarktab4_url}`)
                    }
                  >
                    {user_bookmark?.bookmarks?.bookmarktab4}
                  </span>
                </li>
              ) : user_bookmark?.bookmarks?.bookmarktab5_url !== null ? (
                <li>
                  <span
                    style={{ cursor: "pointer", color: "blue" }}
                    onClick={() =>
                      navigate(`/${user_bookmark?.bookmarks?.bookmarktab5_url}`)
                    }
                  >
                    {user_bookmark?.bookmarks?.bookmarktab5}
                  </span>
                </li>
              ) : (
                "No Bookmark Added"
              )}
            </ul>
          </div>
        </div>

        <div className="shortcuts">
          <h4
            style={{
              display: "flex",
              alignItems: "center",
              fontWeight: "600",
              borderBottom: "1.5px solid #f0f0f0",
              color: "#333",
            }}
          >
            Shortcuts
          </h4>
          <div className="icons-grid">
            {(data.icons || []).map((icon, i) =>
              icon.name.toLowerCase() === "birthday" ? (
                <div
                  key={i}
                  className="icon-item"
                  title={icon.name}
                  onClick={handleShow}
                >
                  {today_birthday.length !== 0 ? (
                    <img src={today_birthday[0].profile} alt="Birthday" />
                  ) : (
                    <img src={icon.icon} alt={icon.name} />
                  )}
                  <span style={{ color: "blue" }}>{icon.name}</span>
                </div>
              ) : (
                <a
                  key={i}
                  href={icon.link}
                  className="icon-item"
                  title={icon.name}
                  rel="noopener noreferrer"
                >
                  <img src={icon.icon} alt={icon.name} />
                  <span>{icon.name}</span>
                </a>
              )
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default RightSidebar;
